<template>
<nav>
  <!-- <v-toolbar class="deep-purple accent-4" src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg" dark> -->
    <v-app-bar app style="background-color: #311B92">
       <v-app-bar-nav-icon @click="drawer = true" class="d-flex d-sm-none" style="color: #0FF"></v-app-bar-nav-icon>
        <v-toolbar-title class="text-uppercase text-center" style="color: #0FF">
            <v-avatar color="teal" size="30">
              <img src="./../assets/avatar.png" alt="Vikash Kumar">
            </v-avatar>
            <span class="font-weight-light ml-1">Random</span>
            <span>Scala</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <div text color="blue darken-2" style="color: white">
          {{ curentDate }}
        </div>
  
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title class="d-none d-sm-flex">
            <v-tabs-slider color="yellow"></v-tabs-slider>
  
            <v-tab v-for="item in items" :key="item.title" :to="item.link" style="color: #0FF">
              <v-icon class="mr-1">{{ item.icon }}</v-icon> {{ item.title }}
            </v-tab>
          </v-tabs>
        </template>
    </v-app-bar>
    <!-- Add a navigation bar -->
    <v-navigation-drawer v-model="drawer" absolute temporary style="height: 100vh; background-color: #311B92">
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item v-for="item in items" :key="item.title" :to="item.link">
            <v-list-item-title @click="tab = item" style="color: #0FF"><v-icon class="mr-1">{{ item.icon }}</v-icon> {{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- Navigation bar ends -->
  <!-- </v-toolbar> -->
</nav>
</template>

<script>
export default {
  el: '#app',
  data () {
    return {
      drawer: false,
      tab: null,
        items: [
          { title: 'Home', icon: 'mdi-home', link: '/' },
          { title: 'My Skills', icon: 'mdi-folder', link: '/skills' },
          { title: 'Projects', icon: 'mdi-home-city', link: '/projects' },
          { title: 'Contact Me', icon: 'mdi-message-text', link: '/contact' },
        ],
    }
  },
  computed: {
    curentDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today = dd + '/' + mm + '/' + yyyy;
      return today;
    }
  }
}
</script>

<style scoped>
i {
  color: #0FF !important;
}
</style>